import { render, staticRenderFns } from "./arac.vue?vue&type=template&id=03879879"
import script from "./arac.vue?vue&type=script&lang=js"
export * from "./arac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports